import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../context/AuthContext";
import HeaderRoutes from "../HeaderRoutes/HeaderRoutes";
import ApiService from "../../functions/apiService";

export default function UserSettingsHeader() {
	const { permission, pages } = useContext(AuthContext);
	const [step, setStep] = useState();

	const headerLinks = [
		{
			label: 'User Settings',
			link: '/firehouse/user-settings',
		},
		{
			label: 'Change Password',
			link: '/firehouse/change-password',
		},
		{
			label: 'Acknowledge Payroll',
			link: '/firehouse/personal-payroll-report',
			hide: !pages.includes("V3_PERSONAL_PAYROLL_ACK"),
		},
	];

	useEffect(() => {
		let i = headerLinks.findIndex((x) => {
			return x.link == window.location.pathname;
		});
		setStep(i);
	}, []);

	return (
		<>
			<div className="d-flex">
				{step != undefined && <HeaderRoutes step={step} steps={headerLinks} />}
			</div>
		</>
	);
}
